module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-avatar",
    style: (_vm.avatarStyle),
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "mu-avatar-inner"
  }, [(_vm.icon) ? _c('icon', {
    class: _vm.iconClass,
    attrs: {
      "value": _vm.icon,
      "size": _vm.iconSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.src) ? _c('img', {
    class: _vm.imgClass,
    attrs: {
      "src": _vm.src
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2e4ea5a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/avatar/avatar.vue
// module id = 3825
// module chunks = 1